import styled from 'styled-components';
import { FONT_STACK } from '../../../../../styles/constants';

export const Container = styled.div`
  ${FONT_STACK};
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  min-height: 52px;
  padding: 8px 0;
`;

export const Visual = styled.div`
  align-items: flex-start;
  align-self: flex-start;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

export const Descriptor = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline-start: 16px;
`;
